export default __webpack_public_path__ + "static/issue-e3be7a4065f50eda014bb465b4e765c6.webp";